// VyomSutra brand constants
export const BRAND = {
  name: "VyomSutra",
  tagline: "Essence of the Infinite",
  taglineHi: "अनंत का सार",
  supporting: "Know Yourself. Build Yourself. Become Future-Ready.",
  supportingHi: "स्वयं को जानिए। स्वयं का निर्माण कीजिए। भविष्य के लिए तैयार बनिए।",
  email: "ccvyom@gmail.com",
  whatsapp: "+91-7428871388",
  whatsappRaw: "917428871388",
  logoUrl:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_careerpath-staging/artifacts/xmhz4dj7_WhatsApp_Image_2026-07-17_at_6.00.35_PM.jpeg",
};

export const PRODUCT_IMAGES = {
  shilajit_hero:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_careerpath-staging/artifacts/vgdih6hy_WhatsApp_Image_2026-07-17_at_6.04.11_PM.jpeg",
  shilajit_pour:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_careerpath-staging/artifacts/xv8fd87n_WhatsApp_Image_2026-07-17_at_6.04.12_PM.jpeg",
  shilajit_drink:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_careerpath-staging/artifacts/knx2b5f7_WhatsApp_Image_2026-07-17_at_6.04.09_PM.jpeg",
};
